var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slds-p-bottom_xx-large",attrs:{"id":"app"}},[_c('nav-bar'),(_vm.isSearchClicked)?_c('CampaignAnalysis',{on:{"filterDataParent":_vm.searchCampaign}}):_vm._e(),_c('error'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }